import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { tagsActions } from '@src/store/reducers/tagTypesReducer';

export const createTagsMiddleware = (http: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [tagsActions.ADD_TAG_TO_OBJECT]: async ({ payload }: any, next: Next) => {
            const url = `${restServiceUrl}Tags/Project/${payload.projectId}/ObjectType/${payload.objectTypeId}/Object/${payload.objectId}`;
            const response = await http.post(url, payload.tags);
            const data = response.data;
            next({ type:tagsActions.GET_OBJECT_TAGS, payload: data });
            return data;
        },
        [tagsActions.GET_OBJECT_TAGS]: async (action: any, next: Next) => {
            const payload = action.payload;
            const url = `${restServiceUrl}Tags/Project/${payload.projectId}/ObjectType/${payload.objectTypeId}/Object/${payload.objectId}`;
            const response = await http.get(url);
            const data = response.data;
            next({ type: action.type, payload: data });
            return data;
        },
        [tagsActions.REMOVE_TAG_FROM_OBJECT]: async ({ payload }: any, next: Next) => {
            try {
                const url = `${restServiceUrl}Tags/Project/${payload.projectId}/ObjectType/${payload.objectTypeId}`
                    + `/Object/${payload.objectId}/TagType/${payload.tagTypeId}/TagName/${payload.tagName}`;
                
                const response = await http({ method: 'delete', url, type: 'applicaiton/json'});
                next({ type: tagsActions.REFRESH_DELETE_TAG, payload: payload.tagName });
                return response.data;
            } catch(error) {
                return error;
            }
        },
        [tagsActions.GET_OBJECT_TYPES]: async () => {
            const response = await http.get(`${restServiceUrl}ObjectTypes`);
            return response;
        },
        [tagsActions.GET_TAGS_FOR_TAG_TYPE]: async ({ payload }: any) => {
            const url = `${restServiceUrl}Tags/TagType/${payload.tagTypeId}/PageNumber/${payload.pageNumber}/PageSize/${payload.pageSize}`;
            const response = await http.get(url);
            return response;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/tags.middleware.ts